import PropTypes from 'prop-types';

const TabGroup = ({
  invoiceLabelsData,
  selectedInvoiceFolioId,
  setSelectedInvoiceFolioId,
}) => (
  <div className="w-full overflow-x-auto bg-pj-gray-400">
    <ul className="custom-scrollbar-horizontal flex w-full gap-4 overflow-x-auto text-2xl italic leading-9">
      {invoiceLabelsData.map(({ folioId, label }) => (
        <li key={folioId} className="list-none">
          <button
            type="button"
            onClick={() => setSelectedInvoiceFolioId(folioId)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setSelectedInvoiceFolioId(folioId);
              }
            }}
            className={`mb-2 min-w-max cursor-pointer px-3 py-2 duration-300 ${
              folioId === selectedInvoiceFolioId && 'bg-pj-primary-200'
            }`}
          >
            {label}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

TabGroup.propTypes = {
  invoiceLabelsData: PropTypes.arrayOf(
    PropTypes.shape({
      folioId: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default TabGroup;
